module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [(_vm.active) ? _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-4-5"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". Your account")])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-5 text-right"
  }, [(_vm.active && _vm.canEdit) ? _c('button', {
    staticClass: "link-lookalike",
    on: {
      "click": _vm.editOverride
    }
  }, [_vm._v("Close")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-20"
  }), _vm._v(" "), (_vm.showSsoButtons) ? _c('SsoButtons') : _vm._e(), _vm._v(" "), (_vm.loginOnly) ? _c('div', {
    staticClass: "pure-u-1"
  }, [_c('p', [_vm._v("A Tavour account with this email already exists. Please log in with your email and password.")]), _vm._v(" "), _c('button', {
    staticClass: "link-lookalike",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginOnly = false
      }
    }
  }, [_vm._v("Make a new account instead")])]) : _vm._e(), _vm._v(" "), (_vm.ssoNewUser) ? _c('div', {
    staticClass: "pure-u-1"
  }, [_c('p', [_vm._v("\n            We did not find a Tavour account for " + _vm._s(_vm.ssoEmail) + ".\n            If you already use the Tavour app, sign in the same way you do there.\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "link-lookalike",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.useOtherSignIn
    }
  }, [_vm._v("Use a different sign-in")]), _vm._v(" "), _c('p', [_vm._v("Or check your name, and we will make your Tavour account.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "pure-u-1 pure-form pure-form-stacked font-14-sm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [(!_vm.loginOnly) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fname),
      expression: "user.fname"
    }],
    staticClass: "pure-input-1",
    attrs: {
      "type": "text",
      "id": "fname"
    },
    domProps: {
      "value": (_vm.user.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "fname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors.fname
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2 padding-bottom-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lname),
      expression: "user.lname"
    }],
    staticClass: "pure-input-1",
    attrs: {
      "type": "text",
      "id": "lname"
    },
    domProps: {
      "value": (_vm.user.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors.lname
    }
  })], 1)] : _vm._e(), _vm._v(" "), (!_vm.isSso) ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2 padding-bottom-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "pure-input-1 margin-bottom-0",
    attrs: {
      "id": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors.email
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "pure-input-1 margin-bottom-0",
    attrs: {
      "id": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors.password
    }
  })], 1), _vm._v(" "), (!_vm.loginOnly) ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }],
    staticClass: "pure-input-1",
    attrs: {
      "id": "password_confirmation",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors.password_confirmation
    }
  })], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2"
  }, [(_vm.loading || _vm.isBusy) ? _c('Loading') : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pure-button pure-button-primary block padding-10",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled
    }
  }, [_vm._v("\n                " + _vm._s(_vm.buttonText) + "\n              ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "text-red"
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e()], 1)], 2)])], 1) : _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-4-5"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". Your account")])]), _vm._v(" "), (_vm.user.email) ? _c('ul', {
    staticClass: "summary pure-u-1"
  }, [_c('li', [_c('div', {
    staticClass: "hidden-sm pure-u-sm-1-5 text-right"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-3-5 padding-left-10"
  }, [_vm._v(_vm._s(this.user.fname) + " " + _vm._s(this.user.lname))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "hidden-sm pure-u-sm-1-5 text-right"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-3-5 padding-left-10"
  }, [_vm._v(_vm._s(this.user.email))])]), _vm._v(" "), (!_vm.isSso) ? _c('li', [_c('div', {
    staticClass: "hidden-sm pure-u-sm-1-5 text-right"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-3-5 padding-left-10"
  }, [_vm._v("************")])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4 text-right-sm"
  }, [_c('label', {
    attrs: {
      "for": "fname"
    }
  }, [_vm._v("First name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4 text-right-sm"
  }, [_c('label', {
    attrs: {
      "for": "lname"
    }
  }, [_vm._v("Last name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4 text-right-sm"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4 text-right-sm"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4 text-right-sm"
  }, [_c('label', {
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("Confirm\n                Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d71ee726!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/UserCreatorDirect.vue
// module id = 413
// module chunks = 1